import { Pipe, PipeTransform } from '@angular/core';
import { UtilService } from '../services/util.service';

@Pipe({
  name: 'dateFormatter'
})
export class DateFormatterPipe implements PipeTransform {

  constructor(private utilService: UtilService) {}

  transform(dates: Date[]): any {
    const datesDisplay = [];
    dates.forEach((date) => {
      datesDisplay.push(this.utilService.convertMomentToDateString(date));
    });
    return datesDisplay.join(', ');
  }

}
